const experiments = require("../client.experiments");

const STORAGE_KEY = "reading_gate_parts_read";

const VARIATIONS = {
  CONTROL: "control",
  VARIATION_A: "signup_after_1",
  VARIATION_B: "signup_after_4"
};

const THRESHOLDS = {
  [VARIATIONS.VARIATION_A]: 1,
  [VARIATIONS.VARIATION_B]: 4
};

const experiment = {
  key: "RGE",
  name: "reading_gate_experiment",
  variations: [
    { name: VARIATIONS.VARIATION_A, weight: 100 },
    { name: VARIATIONS.VARIATION_B, weight: 0 },
    { name: VARIATIONS.CONTROL, weight: 0 }
  ]
};

function getVariation(uuid) {
  return experiments.getVariation(experiment, uuid);
}

function getPartsRead(groupId) {
  try {
    const data = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    return Array.isArray(data[groupId]) ? data[groupId] : [];
  } catch (e) {
    return [];
  }
}

function incrementPartsRead(groupId, partId) {
  try {
    const data = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    const parts = Array.isArray(data[groupId]) ? data[groupId] : [];
    if (!parts.includes(partId)) {
      parts.push(partId);
    }
    data[groupId] = parts;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    return parts.length;
  } catch (e) {
    return 0;
  }
}

/**
 * Returns true if the user's parts-read count for this story group
 * has reached or exceeded their variation's threshold. Returns false
 * if the user has already read `partId` for this group, so we don't
 * gate parts they've already seen.
 *
 * Callers must run this BEFORE incrementing parts-read for the current
 * navigation — otherwise the current partId will be in `parts` and the
 * already-read check will always short-circuit to false.
 */
function shouldGateReading(uuid, groupId, partId) {
  const variation = getVariation(uuid);
  if (variation === VARIATIONS.CONTROL) return false;
  const parts = getPartsRead(groupId);
  if (partId != null && parts.includes(Number(partId))) return false;
  return parts.length >= THRESHOLDS[variation];
}

function sendBucketEvent(uuid, variation = getVariation(uuid)) {
  experiments.sendBucketEvent(experiment, variation);
}

module.exports = {
  EXPERIMENT_KEY: experiment.key,
  VARIATIONS,
  experiment,
  getVariation,
  incrementPartsRead,
  shouldGateReading,
  sendBucketEvent
};
